declare namespace $ {

	type $shm_echarts__option_shm_hitalama_benchmarks_catalog_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_catalog['benchmark_option'] >
		,
		ReturnType< $shm_echarts['option'] >
	>
	type $mol_page__title_shm_hitalama_benchmarks_catalog_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_catalog['benchmark_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_hitalama_benchmarks_catalog_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_catalog['benchmark_body'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_hitalama_textbook_text__text_shm_hitalama_benchmarks_catalog_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_catalog['benchmark_text'] >
		,
		ReturnType< $shm_hitalama_textbook_text['text'] >
	>
	type $shm_hitalama_textbook_text__param_shm_hitalama_benchmarks_catalog_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_textbook_text['param'] >
	>
	type $mol_view__sub_shm_hitalama_benchmarks_catalog_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_benchmarks_catalog extends $mol_book2_catalog {
		benchmark_title( id: any): string
		benchmark_body( id: any): readonly($mol_view)[]
		benchmark_text( id: any): string
		benchmark_option( id: any): any
		Chart( id: any): $shm_echarts
		menu_title( ): string
		param( ): string
		menu_filter_enabled( ): boolean
		Page( id: any): $mol_page
		Text( id: any): $shm_hitalama_textbook_text
		Chart_box( id: any): $mol_view
	}
	
}

//# sourceMappingURL=catalog.view.tree.d.ts.map